import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { catchError, Observable, of } from 'rxjs';
import { Account } from '../user/models/account';
import { ConsultantsClient } from '../user/models/consultants-client.model';
import { ContactSupportAdvisor } from '../user/models/contact-support-advisor';
import { User } from '../user/models/user';
import { UserProfile } from '../user/models/user-profile';
import { UserRepository } from '../user/user.repository';

@Injectable()
export class DefaultUserRepository implements UserRepository {
  private readonly apiBase = '/api/identity/v1';

  constructor(private http: HttpClient) {}

  getUserProfile() {
    return this.http.get<UserProfile>(`${this.apiBase}/profile`);
  }

  getUserAccount() {
    return this.http.get<Account>(`${this.apiBase}/accounts/current`);
  }

  getUserContactSupportAdvisor(): Observable<ContactSupportAdvisor> {
    return this.http.get<ContactSupportAdvisor>(`${this.apiBase}/accounts/current/cs-advisor`);
  }

  getUserInfoById(id: number) {
    return this.http.get<User>(`${this.apiBase}/users/${id}`);
  }

  getConsultantClients() {
    return this.http.get<ConsultantsClient[]>(`${this.apiBase}/accounts/consultant-clients`).pipe(
      catchError(_ => {
        return of([]);
      })
    );
  }
}
